var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row row-hgap-l1"},[_c('div',{staticClass:"col col-vbot",class:`col-${_vm.left}-12`},[_vm._t("left")],2),_c('div',{staticClass:"col col-vbot",class:`col-${_vm.right}-12`},[_vm._t("right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }